import { ListGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";

import { Colors, JobForList, JobList } from '../Api';
import { GroupTitle, ColumnTitle, ListIcon, ListJobTitle, JobSubtitle } from './StyledComponents';
import { Link } from 'react-router-dom';

interface ListViewProps {
  jobList: JobList;
  groupedJobList: Map<string, JobForList[]>;
  tenant: string | undefined;
}

export const ListView = (props: ListViewProps) => {

  const sortedJobList = new Map([...props.groupedJobList.entries()].sort());

  return (
    <div style={{ marginTop: "30px" }}>
      {
        [...sortedJobList.keys()].map(group =>
          <Group key={group} group={group} jobList={props.jobList} groupedJobList={props.groupedJobList} tenant={props.tenant}/>
        )
      }
    </div>
  );
}

interface ListItemProps {
  colors: Colors
  job: JobForList
}

interface GroupProps {
  group: string
  jobList: JobList;
  groupedJobList: Map<string, JobForList[]>;
  tenant: string | undefined;
}

export const Group = (props: GroupProps) => {
  const [expanded, setExpanded] = useState(true);
  const [iconGroup, setIconGroup] = useState(solid('chevron-down'));

  return (
    <div style={{ paddingTop: "2px", paddingBottom: "2px" }}>
      <div style={{ display: "flex"}}>
        <div style={{ padding: "34px 14px 14px 0px"}}>
          {props.group && <FontAwesomeIcon icon={iconGroup} onClick={() => {
            setIconGroup(expanded ? solid('chevron-right') : solid('chevron-down'));
            setExpanded(!expanded);
          }} />}
        </div>
        {props.group && <GroupTitle>{props.group}</GroupTitle>}
      </div>
      {expanded && <ListGroup>
        {props.groupedJobList.get(props.group)?.map(job =>
          <Link key={job.id} to={`../../../${props.tenant}/${props.jobList.name}/${job.id}`} target= {props.jobList.directIntegrationIframe ? "":"_blank"} rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            <ListItem key={job.id} job={job} colors={props.jobList.colors} />
          </Link>
        )}
      </ListGroup>}
    </div>
  );
}

function isMobile() {
  const minWidth = 768; // Minimum width for desktop devices
  return window.innerWidth < minWidth || window.screen.width < minWidth;
}

export const ListItem = (props: ListItemProps) => {
  const location = props.job.locations?.length > 0 ? props.job.locations.sort().join(", ") : ""
  const mobile = isMobile(); 
  return (
    <ListGroup.Item
      key={props.job.id}
      className="d-flex justify-content-between align-items-start" style={{ paddingTop: "12px", paddingBottom: "4px", marginBottom: "12px", borderRadius: "10px" }}
      action >
      { !mobile &&
      <div className="ms-2 me-auto">
        <ListJobTitle className={"ListJobTitle"} colors={props.colors}>
          {props.job.title}
        </ListJobTitle>
        <JobSubtitle className={"JobSubtitle"}>
          {props.job.subtitle}
        </JobSubtitle>
      </div>
      }
      {!mobile && location !== "" && <ListIcon icon={solid('map-marker')} size="xs" title={location} />}
      { !mobile &&
      <ColumnTitle>
        {location}
      </ColumnTitle>
      }

      { mobile && <div style={{ paddingBottom: "20px", display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
        <div className="ms-2 me-auto" style={{ padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <ListJobTitle className={"ListJobTitle"} colors={props.colors}>
            {props.job.title}
          </ListJobTitle>
          <JobSubtitle className={"JobSubtitle"}>
            {props.job.subtitle}
          </JobSubtitle>
        </div>
        <div style={{ padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {location !== "" && <ListIcon icon={solid('map-marker')} size="xs" title={location} />}
          <ColumnTitle style={{ padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {location}
          </ColumnTitle>
          </div>
        </div>
      }

    </ListGroup.Item>
  );
}

